// import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    FormControl,
//    FormErrorMessage,
//    Input,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    Box,
//    Stepper,
//    Step,
//    StepIndicator,
//    StepStatus,
//    StepIcon,
//    StepNumber,
//    StepTitle,
//    StepDescription,
//    StepSeparator,
//    useToast,
//    FormLabel,
// } from '@chakra-ui/react';
// import { useDispatch, useSelector } from 'react-redux';
// import { addCategory, getCategory, updateCategory } from '../../../../../redux/actions/category';
// import { renderFormControl } from 'utils/DynamicFormData';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { renderDynamicDropdown as renderDynamicUiDropdown } from '../../../../../components/ui/DynamicDropdown';
// import { getShareCompanyOptions } from '../../../../../utils/util';
// import { useUser } from 'contexts';
// import { useGlobal } from '../../../../../contexts';

// // Yup Validation Schema
// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
// });

// const steps = [
//    { title: 'First', description: 'Enter Item Information' },
//    { title: 'Second', description: 'Review and Save' },
// ];

// const CategoryMasterForm = ({ isOpen, onClose, isEditMode = false, currentRow = null, onSave }) => {
//    const [row, setRow] = useState({
//       name: '',
//       ordinal: '',
//       compIds: [],
//    });
//    const { companyList, userGlobalSettingsData } = useGlobal();
//    const [errors, setErrors] = useState({});
//    const [isLoading, setIsLoading] = useState(false);
//    const [activeStep, setActiveStep] = useState(0);
//    const toast = useToast();
//    const { user } = useUser();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();

//    const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.category;
//    const shouldShowCompanyDropdown = globalSetting || false;
//    const categories = useSelector((state) => state.category.list || []);
//    const [categoryData, setCategoryData] = useState({});

//    const getNextOrdinalValue = () => {
//       if (!categories || categories.length === 0) return 1;

//       // Find the highest ordinal value
//       const highestOrdinal = Math.max(...categories.map((cat) => Number(cat.ordinal) || 0));

//       // Return the next value
//       return highestOrdinal + 1;
//    };

//    useEffect(() => {
//       if (!isEditMode) {
//          // For new category, use the next ordinal value
//          setRow({
//             name: '',
//             ordinal: Number(getNextOrdinalValue()),
//          });
//       } else if (isEditMode && currentRow) {
//          // For editing, use the current values
//          setRow({
//             name: currentRow.name || '',
//             ordinal: currentRow.ordinal || '',
//             compIds: currentRow.compIds || currentRow.companyIds || [],
//          });
//       }
//    }, [isEditMode, currentRow, categories]);

//    useEffect(() => {
//       setCategoryData(categories); // Update table when categories change
//    }, [categories]);

//    // Function to clear form data
//    const clearFormData = () => {
//       setRow({
//          name: '',
//          ordinal: isEditMode ? '' : String(getNextOrdinalValue()),
//       });
//       setErrors({});
//    };

//    // Populate form with current row data when in edit mode
//    // useEffect(() => {
//    //   if (!isEditMode) {
//    //     clearFormData(); // Clear data when adding a new item
//    //   } else if (isEditMode && currentRow) {
//    //     setRow({
//    //       name: currentRow.name || '',
//    //       ordinal: currentRow.ordinal || '',
//    //     });
//    //   }
//    // }, [isEditMode, currentRow]);

//    const validateStep = async () => {
//       try {
//          // Validate the whole row object instead of individual fields
//          await validationSchema.validate(row, { abortEarly: false });

//          setErrors({}); // Clear previous errors
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             // setErrors(errorObj);
//             setErrors({});
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: value,
//       }));
//       if (field === 'ordinal') {
//          // Only convert to number if value is not empty
//          value = value ? Number(value) : '';
//       }

//       // Clear the specific field error when user starts typing
//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    const handleNext = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          if (activeStep < steps.length - 1) {
//             setActiveStep(activeStep + 1);
//          }
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before proceeding.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlePrevious = () => {
//       if (activeStep > 0) {
//          setActiveStep(activeStep - 1);
//       }
//    };

//    const onFormSubmit = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          ordinal: Number(row.ordinal),
//          compIds: row.compIds,
//          // primaryuqcid: Number(row.primaryuqcid),
//          // ratepersalesid: Number(row.ratepersalesid),
//          // rateperpurchaseid: Number(row.rateperpurchaseid)
//       };

//       setErrors({});
//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateCategory(processedData));
//          } else {
//             // Add new item
//             await dispatch(addCategory(processedData));
//             // await dispatch(getCategory({ ...processedData, compIds: user.loginhistory.companyId }));
//          }
//          setIsLoading(false);

//          // Close the modal
//          onClose();
//       } catch (error) {
//          // toast({
//          //   title: 'Error',
//          //   description:
//          //     error.message || 'An error occurred while saving the category.',
//          //   status: 'error',
//          //   duration: 3000,
//          //   isClosable: true,
//          // });
//          setIsLoading(false);
//       }
//    };

//    const onsavecontinue = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          ordinal: Number(row.ordinal),
//          compIds: row.compIds,
//          // primaryuqcid: Number(row.primaryuqcid),
//          // ratepersalesid: Number(row.ratepersalesid),
//          // rateperpurchaseid: Number(row.rateperpurchaseid)
//       };

//       setErrors({});
//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateCategory(processedData));
//          } else {
//             // Add new item
//             await dispatch(addCategory(processedData));
//             // await dispatch(getCategory({ ...processedData, companyIds: user.loginhistory.companyId }));
//          }
//          setIsLoading(false);

//          // Close the modal
//          // onClose();
//       } catch (error) {
//          // toast({
//          //   title: 'Error',
//          //   description:
//          //     error.message || 'An error occurred while saving the category.',
//          //   status: 'error',
//          //   duration: 3000,
//          //   isClosable: true,
//          // });
//          setIsLoading(false);
//       }
//    };

//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' || // for react-select input
//             activeElement?.isContentEditable;

//          if (isTyping) return; // Don't trigger shortcuts while typing

//          if (e.key.toLowerCase() === 's') {
//             e.preventDefault();

//             if (e.shiftKey) {
//                handlesavecontinue(); // SHIFT + S --- save & continue
//             } else {
//                handleSubmit(); // S --- Save & Finish
//             }
//          }
//          if (e.key.toLowerCase() === 'c') {
//             onClose(); // c --- cansel
//          }
//          if (e.key.toLowerCase() === 'p') {
//             handlePrevious(); // p --- Previous
//          }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateStep]);

//    const handleSubmit = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onFormSubmit(); // Call the form submit logic if validation is successful
//       } else {
//          if (!row.name || row.name.trim() === '') {
//             setActiveStep(0);

//             setTimeout(() => {
//                nameInputRef.current?.focus(); // Focus the name input
//             }, 100);

//             return;
//          }
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onsavecontinue(); // Call the form submit logic if validation is successful
//       } else {
//          if (!row.name || row.name.trim() === '') {
//             setActiveStep(0);

//             setTimeout(() => {
//                nameInputRef.current?.focus(); // Focus the name input
//             }, 100);

//             return;
//          }
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const nameInputRef = useRef();
//    const ordinalRef = useRef(null);
//    const saveFinishRef = useRef(null);

//    useEffect(() => {
//       setTimeout(() => {
//          nameInputRef.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isOpen]);

//    const handleCompanyChange = useCallback((selectedOptions) => {
//       setRow((prev) => ({
//          ...prev,
//          compIds: selectedOptions ?? [],
//       }));
//    }, []);

//    const dbName = localStorage.getItem('dbName');

//    const companyOptions = useMemo(() => {
//       return getShareCompanyOptions({ dbName, company: companyList });
//    }, [companyList, dbName]);

//    const lastcompanyOptions = useMemo(
//       () =>
//          companyOptions.map((company) => ({
//             value: company.value,
//             label: company.label,
//             id: company.value,
//             name: company.label,
//          })),
//       [companyOptions],
//    );

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === "Escape") {
//             e.preventDefault();
//             onClose();
//          }
//       };

//       document.addEventListener("keydown", handleEsc);
//       return () => {
//          document.removeEventListener("keydown", handleEsc);
//       };
//    }, [onClose]);

//    return (
//       <Modal isOpen={isOpen} onClose={onClose} size="3xl">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '45%', md: '25%', xl: '15%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
//                {isEditMode ? 'Edit Category' : 'Add New Category'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                {/* <Stepper index={activeStep} colorScheme="teal">
//             {steps.map((step, index) => (
//               <Step key={index}>
//                 <StepIndicator>
//                   <StepStatus
//                     complete={<StepIcon />}
//                     incomplete={<StepNumber />}
//                     active={<StepNumber />}
//                   />
//                 </StepIndicator>
//                 <Box flexShrink="0">
//                   <StepTitle>{step.title}</StepTitle>
//                   <StepDescription>{step.description}</StepDescription>
//                 </Box>
//                 <StepSeparator />
//               </Step>
//             ))}
//           </Stepper> */}

//                {/* {activeStep === 0 && ( */}
//                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(2, 1fr)' }} gap={6}>
//                   <GridItem>
//                      {DynamicInput(
//                         'name',
//                         'Name',
//                         {
//                            value: row.name,
//                            onChange: (e) => handleInputChange('name', e.target.value),
//                            ref: nameInputRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  ordinalRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem>
//                      {DynamicInput(
//                         'ordinal',
//                         'Ordinal',
//                         {
//                            value: row.ordinal,
//                            onChange: (e) => handleInputChange('ordinal', e.target.value),
//                            ref: ordinalRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  saveFinishRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'number',
//                         true, // Mark as required
//                      )}
//                   </GridItem>
//                   {shouldShowCompanyDropdown && (
//                      <GridItem className="seperator-width">
//                         {renderDynamicUiDropdown(
//                            'company',
//                            'Company',
//                            lastcompanyOptions,
//                            {
//                               value: row.compIds,
//                               onChange: handleCompanyChange,
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select company',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   )}
//                </Grid>
//                {/* )} */}

//                {activeStep === 1 && (
//                   <Box mt={8}>
//                      <strong>Name:</strong> {row.name}
//                      <br />
//                      <strong>Ordinal:</strong> {row.ordinal}
//                      <br />
//                   </Box>
//                )}
//             </ModalBody>
//             <ModalFooter>
//                {activeStep > 0 && (
//                   <Button
//                      onClick={handlePrevious}
//                      variant="ghost"
//                      colorScheme="teal"
//                      mr={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      Previous
//                   </Button>
//                )}

//                {/* {activeStep < steps.length - 1 && (
//             <Button onClick={handleNext} colorScheme="teal">
//               Next
//             </Button>
//           )} */}
//                {!isEditMode && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      ml={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      save & continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSubmit}
//                   ref={saveFinishRef}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   colorScheme="green"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}>
//                   Save & Finish
//                </Button>

//                <Button variant="ghost" onClick={onClose} ml={3} _focus={{ outlineColor: 'blue.500 ' }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default CategoryMasterForm;

import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   Box,
   useToast,
   useColorMode,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { addCategory, updateCategory } from '../../../../../redux/actions/category';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown as renderDynamicUiDropdown } from '../../../../../components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useUser } from 'contexts';
import { useGlobal } from '../../../../../contexts';

// Yup Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
});

const steps = [
   { title: 'First', description: 'Enter Item Information' },
   { title: 'Second', description: 'Review and Save' },
];

const CategoryMasterForm = ({ isOpen, onClose, isEditMode = false, currentRow = null, onSave }) => {
   const [row, setRow] = useState({
      name: '',
      ordinal: '',
      compIds: [],
   });
   const { companyList, userGlobalSettingsData } = useGlobal();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [errors, setErrors] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const [activeStep, setActiveStep] = useState(0);
   const toast = useToast();
   const { user } = useUser();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const dispatch = useDispatch();

   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.category;
   const shouldShowCompanyDropdown = globalSetting || false;
   const categories = useSelector((state) => state.category.list || []);
   const [categoryData, setCategoryData] = useState({});

   const getNextOrdinalValue = () => {
      if (!categories || categories.length === 0) return 1;

      // Find the highest ordinal value
      const highestOrdinal = Math.max(...categories.map((cat) => Number(cat.ordinal) || 0));

      // Return the next value
      return highestOrdinal + 1;
   };

   useEffect(() => {
      if (!isEditMode) {
         // For new category, use the next ordinal value
         setRow({
            name: '',
            ordinal: Number(getNextOrdinalValue()),
         });
      } else if (isEditMode && currentRow) {
         // For editing, use the current values
         setRow({
            name: currentRow.name || '',
            ordinal: currentRow.ordinal || '',
            compIds: currentRow.compIds || currentRow.companyIds || [],
         });
      }
   }, [isEditMode, currentRow, categories]);

   useEffect(() => {
      setCategoryData(categories); // Update table when categories change
   }, [categories]);

   const validateStep = async () => {
      try {
         // Validate the whole row object instead of individual fields
         await validationSchema.validate(row, { abortEarly: false });

         setErrors({}); // Clear previous errors
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            // setErrors(errorObj);
            setErrors({});
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));
      if (field === 'ordinal') {
         // Only convert to number if value is not empty
         value = value ? Number(value) : '';
      }

      // Clear the specific field error when user starts typing
      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const handlePrevious = () => {
      if (activeStep > 0) {
         setActiveStep(activeStep - 1);
      }
   };

   const onFormSubmit = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         ordinal: Number(row.ordinal),
         compIds: row.compIds,
      };

      setErrors({});
      try {
         if (isEditMode && currentRow && currentRow.id) {
            // Update existing item
            processedData.id = currentRow.id;
            await dispatch(updateCategory(processedData));
         } else {
            // Add new item
            await dispatch(addCategory(processedData));
         }
         setIsLoading(false);

         // Close the modal
         onClose();
      } catch (error) {
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         ordinal: Number(row.ordinal),
         compIds: row.compIds,
      };

      setErrors({});
      try {
         if (isEditMode && currentRow && currentRow.id) {
            // Update existing item
            processedData.id = currentRow.id;
            await dispatch(updateCategory(processedData));
         } else {
            // Add new item
            await dispatch(addCategory(processedData));
            // await dispatch(getCategory({ ...processedData, companyIds: user.loginhistory.companyId }));
         }
         setIsLoading(false);

         // Close the modal
         // onClose();
      } catch (error) {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' || // for react-select input
            activeElement?.isContentEditable;

         if (isTyping) return; // Don't trigger shortcuts while typing

         if (isOpen && e.key.toLowerCase() === 's') {
            e.preventDefault();

            if (e.shiftKey) {
               handlesavecontinue(); // SHIFT + S --- save & continue
            } else {
               handleSubmit(); // S --- Save & Finish
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            onClose(); // c --- cansel
         }
         if (isOpen && e.key.toLowerCase() === 'p') {
            handlePrevious(); // p --- Previous
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit(); // Call the form submit logic if validation is successful
      } else {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue(); // Call the form submit logic if validation is successful
      } else {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const nameInputRef = useRef();
   const ordinalRef = useRef(null);
   const saveFinishRef = useRef(null);
   const cancelRef = useRef(null);
   const savecontinueRef = useRef(null);

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isOpen]);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);

   const dbName = localStorage.getItem('dbName');

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            onClose();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [onClose]);

   return (
      <div className={`h-90vh flex items-center justify-center ${isDark ? 'bg-gray-900' : 'bg-gray-100'}`}>
         <Modal isOpen={isOpen} onClose={onClose} size="3xl">
            <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
            <ModalContent bg="transparent" boxShadow="none" mx="15px" mt={{ base: '45%', md: '25%', xl: '15%' }}>
               <div
                  className={`rounded-2xl shadow-xl overflow-hidden
            ${isDark ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'}
          `}>
                  {/* Colored top border */}
                  <div className="h-1 bg-gradient-to-r from-purple-500 via-blue-500 to-indigo-500" />

                  {/* Header */}
                  <ModalHeader className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                     <div className="flex items-center gap-3">
                        <div className="w-1 h-8 bg-gradient-to-b from-purple-500 to-blue-500 rounded-full" />
                        <div>
                           <h2 className={`text-xl font-semibold ${isDark ? 'text-purple-400' : 'text-purple-600'}`}>
                              {isEditMode ? 'Edit Category' : 'Add New Category'}
                           </h2>
                           <p className={`text-xs mt-0.5 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                              {isEditMode ? 'Update category details' : 'Create a new category for your organization'}
                           </p>
                        </div>
                     </div>
                  </ModalHeader>

                  <ModalCloseButton
                     className={`top-5 right-5 rounded-md ${isDark
                        ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700'
                        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                        }`}
                     _focus={{
                        boxShadow: '0 0 0 2px rgba(99, 102, 241, 0.5)',
                        outline: 'none',
                     }}
                  />

                  {/* Body */}
                  <ModalBody className="px-6 py-5">
                     <Grid
                        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(2, 1fr)' }}
                        gap={4}>
                        <GridItem>
                           {DynamicInput(
                              'name',
                              'Category Name',
                              {
                                 value: row.name,
                                 onChange: (e) => handleInputChange('name', e.target.value),
                                 ref: nameInputRef,
                                 placeholder: 'Enter name',
                                 onKeyDown: (e) => {
                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                       e.preventDefault();
                                       ordinalRef.current?.focus();
                                    }
                                 },
                              },
                              errors,
                              textColor,
                              'text',
                              true,
                           )}
                        </GridItem>

                        <GridItem>
                           {DynamicInput(
                              'ordinal',
                              'Display Order',
                              {
                                 value: row.ordinal,
                                 onChange: (e) => handleInputChange('ordinal', e.target.value),
                                 ref: ordinalRef,
                                 placeholder: '44',
                                 onKeyDown: (e) => {
                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                       e.preventDefault();
                                       saveFinishRef.current?.focus();
                                    }
                                 },
                              },
                              errors,
                              textColor,
                              'number',
                              true,
                           )}
                        </GridItem>

                        {shouldShowCompanyDropdown && (
                           <GridItem className="seperator-width">
                              {renderDynamicUiDropdown(
                                 'company',
                                 'Company',
                                 lastcompanyOptions,
                                 {
                                    value: row.compIds,
                                    onChange: handleCompanyChange,
                                 },
                                 {},
                                 textColor,
                                 false,
                                 'Select company',
                                 true,
                                 undefined,
                                 true,
                              )}
                           </GridItem>
                        )}
                     </Grid>

                     {activeStep === 1 && (
                        <Box
                           mt={5}
                           className={`p-4 rounded-lg border
                    ${isDark ? 'bg-gray-700/50 border-gray-600' : 'bg-gray-50 border-gray-200'}
                  `}>
                           <div className="space-y-2 text-sm">
                              <div className="flex items-center gap-2">
                                 <span className={`font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                    Name:
                                 </span>
                                 <span className={isDark ? 'text-gray-100' : 'text-gray-900'}>{row.name}</span>
                              </div>
                              <div className="flex items-center gap-2">
                                 <span className={`font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                    Ordinal:
                                 </span>
                                 <span className={isDark ? 'text-gray-100' : 'text-gray-900'}>{row.ordinal}</span>
                              </div>
                           </div>
                        </Box>
                     )}
                  </ModalBody>

                  {/* Footer */}
                  <ModalFooter
                     className={`px-6 py-4 border-t flex flex-wrap gap-3 justify-end ${
                        isDark
                           ? 'border-gray-700/50 bg-gradient-to-r from-gray-800/50 to-gray-900/50'
                           : 'border-gray-200 bg-gradient-to-r from-gray-50 to-white'
                     }`}>
                     {activeStep > 0 && (
                        <Button
                           onClick={handlePrevious}
                           size="sm"
                           className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 shadow-sm hover:shadow-md transform hover:-translate-y-0.5
        ${
           isDark
              ? 'bg-gradient-to-r from-gray-700 to-gray-600 text-gray-100 hover:from-gray-600 hover:to-gray-500 border border-gray-500/50'
              : 'bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-300 hover:border-gray-400'
        }
      `}
                           _focus={{
                              boxShadow: isDark
                                 ? '0 0 0 3px rgba(99, 102, 241, 0.4)'
                                 : '0 0 0 3px rgba(99, 102, 241, 0.3)',
                              outline: 'none',
                           }}>
                           <span className="flex items-center gap-2">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                 <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M15 19l-7-7 7-7"
                                 />
                              </svg>
                              Previous
                           </span>
                        </Button>
                     )}

                     {!isEditMode && (
                        <Button
                           ref={savecontinueRef}
                           onClick={handlesavecontinue}
                           isLoading={isLoading}
                           disabled={isLoading}
                           size="sm"
                           className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5
        ${
           isDark
              ? 'bg-gradient-to-r from-emerald-600 to-emerald-500 text-white hover:from-emerald-500 hover:to-emerald-400 border border-emerald-400/50'
              : 'bg-gradient-to-r from-emerald-500 to-emerald-600 text-white hover:from-emerald-600 hover:to-emerald-700 border-2 border-emerald-400/30'
        }
      `}
                           _focus={{
                              boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.4)',
                              outline: 'none',
                           }}
                           onKeyDown={(e) => {
                              if (e.key === 'ArrowRight') {
                                 e.preventDefault();
                                 saveFinishRef.current?.focus();
                              }
                           }}>
                           <span className="flex items-center gap-2">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                 <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M5 13l4 4L19 7"
                                 />
                              </svg>
                              Save & Continue
                           </span>
                        </Button>
                     )}

                     <Button
                        onClick={handleSubmit}
                        ref={saveFinishRef}
                        isLoading={isLoading}
                        disabled={isLoading}
                        size="sm"
                        className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5
      ${
         isDark
            ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-500 hover:to-blue-400 border border-blue-400/50'
            : 'bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 border-2 border-blue-400/30'
      }
    `}
                        _focus={{
                           boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)',
                           outline: 'none',
                        }}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              cancelRef.current?.focus();
                           } else if (e.key === 'ArrowLeft') {
                              e.preventDefault();
                              if (!isEditMode) {
                                 savecontinueRef.current?.focus();
                              }
                           }
                        }}>
                        <span className="flex items-center gap-2">
                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth={2}
                                 d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                           </svg>
                           Save & Finish
                        </span>
                     </Button>

                     <Button
                        ref={cancelRef}
                        onClick={onClose}
                        size="sm"
                        className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 shadow-sm hover:shadow-md transform hover:-translate-y-0.5
      ${
         isDark
            ? 'bg-gradient-to-r from-red-600/80 to-red-500/80 text-white hover:from-red-500 hover:to-red-400 border border-red-400/50'
            : 'bg-white text-red-600 hover:bg-red-50 border-2 border-red-300 hover:border-red-400'
      }
    `}
                        _focus={{
                           boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.3)',
                           outline: 'none',
                        }}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowLeft') {
                              e.preventDefault();
                              saveFinishRef.current?.focus();
                           }
                        }}>
                        <span className="flex items-center gap-2">
                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth={2}
                                 d="M6 18L18 6M6 6l12 12"
                              />
                           </svg>
                           Cancel
                        </span>
                     </Button>
                  </ModalFooter>
               </div>
            </ModalContent>
         </Modal>
      </div>
   );
};

export default CategoryMasterForm;
